import loadable from "@loadable/component";
export const ForgotPasswordPage = loadable(() => import("./ForgotPassword"));
